import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserStore } from "@src/stores/userStore";

const PrivateRoute = () => {
    const authenticate = useUserStore.getState().authenticate;
    const token = localStorage.getItem("token");
    let location = useLocation();
    if (!token) {
        return <Navigate to="/login" state={{ from: location }} />;
    } else {
        authenticate();
    }
    return <Outlet />;
};

export default PrivateRoute;
